// Default K-Walk homepage content — used as fallback when db.site_content is empty
// so production always renders correctly even before admin edits the Site Content tab.
export const HOME_DEFAULTS = {
  hero_tag: "Since 2011 · Agra, India",
  hero_headline: "Comfort in every step. Craftsmanship in every detail.",
  hero_subtext: "A legacy of footwear, proudly built since 2011.",
  hero_image_url:
    "https://i.postimg.cc/zBN3RfVR/Chat-GPT-Image-Jul-6-2026-01-35-10-PM-%281%29.jpg",
  hero_caption: "K-Walk · Crafted for Comfort · Built to Last",
  story_heading: "Walking Forward Since 2011.",
  story_p1:
    "K-Walk was founded with a simple yet meaningful purpose — to create footwear that blends comfort, quality, and enduring craftsmanship. At the heart of K-Walk lies a family legacy. The name is inspired by Krishna Murari, our grandfather, whose values, determination, and entrepreneurial spirit continue to guide us. Naming the brand after him is our tribute to the foundation he laid.",
  story_p2:
    "K-Walk is the vision of our founder, Jitendra Kumar Middha, whose creativity, dedication, and commitment to excellence have shaped the brand from its inception. As the driving force behind every collection and design, his passion for footwear has transformed an idea into a growing legacy that continues to evolve with every season.",
  story_p3:
    "Since 2011, we have remained committed to crafting footwear that not only complements modern lifestyles but also delivers lasting comfort and exceptional quality. Today, K-Walk is proudly and exclusively available at B.K. Shoe, Agra — the place where our story first began. Here's to our roots, our journey, and the many milestones yet to come.",
  story_image_url: "",
  founded_year: "2011",
  stat_1_label: "Since",
  artisan_count: "3",
  stat_2_label: "Generations",
  steps_count: "Agra",
  stat_3_label: "Home",
  marquee:
    "SINCE 2011 | MADE IN INDIA | AGRA CRAFTSMANSHIP | FAMILY LEGACY | EXCLUSIVELY AT B.K. SHOE",
};
